// extracted by mini-css-extract-plugin
export default {"InfoContainer":"CardInfo_InfoContainer__n58Lx","Yellow":"CardInfo_Yellow__4QFZy","Blue":"CardInfo_Blue__mLM45","White":"CardInfo_White__9l-C7"};